import { getToken, doFetch } from './utils/Fetching.js';
import { toast_message } from './utils/toast_message.js';
import { api_host, all_users_store, all_jobs_store, all_jobs_number_store, price_setting_store, company_details_store, 
    invoices_store, all_quotes_store, places_store, transactions_store, referrals_store, coupons_store, total_earned_store, 
    business_hours_store, user_store, user_info_store, subscription_store, billing_history_store, 
    expenses_store, expense_category_store, page_setting_store
} from './stores.js';


export const init_data = async (init_type) => {
    const { auth_type, auth_token, domain_code } = getToken();

    if (!auth_type || !auth_token) { return; }

    let prev_error_msg = '';

    if (init_type === 'all' || init_type === 'numbers') {
        const numbers_res = await doFetch(
            `${api_host}/api/job/get/numbers`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (numbers_res.status) {
            all_jobs_number_store.set(numbers_res.numbers);
        } else {
            const error_msg = numbers_res.msg || 'Fetching users failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'users') {
        const all_users_res = await doFetch(
            `${api_host}/api/get/user/all`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );

        if (all_users_res.status) {
            all_users_store.set(all_users_res.users);
        }
        else {
            const error_msg = all_users_res.msg || 'Fetching users failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'jobs') {
        const all_jobs_res = await doFetch(
            `${api_host}/api/job/get/all/1`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );

        if (all_jobs_res.status) {
            all_jobs_store.set(all_jobs_res.jobs);
            if (all_jobs_res.is_lazy_loaded) {
                new Promise(async (resolve, reject) => {
                    const rest_all_jobs_res = await doFetch(
                        `${api_host}/api/job/get/all/0`,
                        'GET',
                        null,
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    all_jobs_store.set([...all_jobs_res.jobs, ...rest_all_jobs_res.jobs]);
                });
            }
        } else {
            const error_msg = all_jobs_res.msg || 'Fetching jobs failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'prices') {
        const price_setting_res = await doFetch(
            `${api_host}/api/landscaper/get/price_setting`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (price_setting_res.status) {
            price_setting_store.set(price_setting_res.price_setting);
        } else {
            const error_msg = price_setting_res.msg || 'Fetching prices failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'pages') {
        const page_setting_res = await doFetch(
            `${api_host}/api/landscaper/get/page_setting`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (page_setting_res.status) {
            page_setting_store.set(page_setting_res.page_setting);
        } else {
            const error_msg = page_setting_res.msg || 'Fetching page setting failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'company_details') {
        const company_details_res = await doFetch(
            `${api_host}/api/landscaper/get/company_detail`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (company_details_res.status) {
            company_details_store.set({...company_details_res.company_details, ...company_details_res.owner, tax_rates: company_details_res.tax_rates});
            business_hours_store.set(company_details_res.business_hours);
        } else {
            const error_msg = company_details_res.msg || 'Fetching company details failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'invoices') {
        const invoices_res = await doFetch(
            `${api_host}/api/invoice/get/all`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (invoices_res.status) {
            const { invoices } = invoices_res;
            invoices_store.set(invoices);
        } else {
            const error_msg = invoices_res.msg || 'Fetching invoices failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'all' || init_type === 'quotes') {
        const quotes_res = await doFetch(
            `${api_host}/api/quote/get/all/1`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (quotes_res.status) {
            all_quotes_store.set(quotes_res.quotes);
            if (quotes_res.is_lazy_loaded) {
                new Promise(async (resolve, reject) => {
                    const rest_quotes_res = await doFetch(
                        `${api_host}/api/quote/get/all/0`,
                        'GET',
                        {},
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    all_quotes_store.set([...quotes_res.quotes, ...rest_quotes_res.quotes]);
                });
            }
        } else {
            toast_message(false, quotes_res.msg || 'Fetching quotes failed', 3000);
        }
    }

    if (init_type === 'all' || init_type === 'places') {
        const places_res = await doFetch(
            `${api_host}/api/landscaper/get/places`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (places_res.status) {
            places_store.set(places_res.places);
        } else {
            const error_msg = places_res.msg || 'Fetching places failed';
            if (prev_error_msg !== error_msg)
                toast_message(false, error_msg, 3000);
            prev_error_msg = error_msg;
        }
    }

    if (init_type === 'transactions') {
        const transactions_res = await doFetch(
            `${api_host}/api/transaction/get/all/1`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (transactions_res.status) {
            transactions_store.set(transactions_res.transactions);
            if (transactions_res.is_lazy_loaded) {
                new Promise(async (resolve, reject) => {
                    const rest_transactions_res = await doFetch(
                        `${api_host}/api/transaction/get/all/0`,
                        'GET',
                        {},
                        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                    );
                    transactions_store.set([...transactions_res.transactions, ...rest_transactions_res.transactions]);
                });
            }
        } else {
            toast_message(false, transactions_res.msg || 'Fetching transactions failed', 3000);
        }
    }

    if (init_type === 'referrals') {
        const referrals_res = await doFetch(
            `${api_host}/api/referral/get/all`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (referrals_res.status) {
            referrals_store.set(referrals_res.referrals);
        } else {
            toast_message(false, referrals_res.msg || 'Fetching referrals failed', 3000);
        }
    }

    if (init_type === 'subscription') {
        const subscription_res = await doFetch(
            `${api_host}/api/subscription/get/self`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (subscription_res.status) {
            subscription_store.set(subscription_res.subscription);
        } else {
            toast_message(false, subscription_res.msg || 'Fetching subscription failed', 3000);
        }
    }

    if (init_type === 'coupons') {
        const coupon_res = await doFetch(
            `${api_host}/api/coupon/get/all`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (coupon_res.status) {
            coupons_store.set(coupon_res.coupons);
        } else {
            toast_message(false, coupon_res.msg || 'Fetching coupons failed', 3000);
        }
    }

    if (init_type === 'expenses') {
        const expense_res = await doFetch(
            `${api_host}/api/expense/get/all`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (expense_res.status) {
            expenses_store.set(expense_res.expenses);
        } else {
            toast_message(false, expense_res.msg || 'Fetching expenses failed', 3000);
        }
    }

    if (init_type === 'expense_category') {
        const expense_category_res = await doFetch(
            `${api_host}/api/expense/category/get/all`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (expense_category_res.status) {
            expense_category_store.set(expense_category_res.expense_categories);
        } else {
            toast_message(false, expense_category_res.msg || 'Fetching expense categories failed', 3000);
        }
    }

    if (init_type === 'billing_history') {
        const billing_history_res = await doFetch(
            `${api_host}/api/landscaper/billing/history`,
            'GET',
            null,
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        if (billing_history_res.status) {
            billing_history_store.set(billing_history_res.billing_history);
        } else {
            toast_message(false, billing_history_res.msg || 'Fetching billing history failed', 3000);
        }
    }

    if (init_type === 'myself') {
        const res = await doFetch(
            api_host + `/auth/user`,
            'GET',
            {},
            { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
        );
        const { email, is_trial, first_name, last_name, id, username, role, is_subscribed, plan_type, plan_freq, paid_at, subscription } = res;
        if (res['id']) {
            user_store.update(prev => {
                prev['is_trial'] = is_trial;
                prev['is_authenticated'] = true;
                prev['is_subscribed'] = is_subscribed;
                prev['email'] = email;
                prev['first_name'] = first_name;
                prev['last_name'] = last_name;
                prev['id'] = id;
                prev['username'] = username;
                prev['role'] = role;
                prev['plan_type'] = plan_type;
                prev['plan_freq'] = plan_freq;
                prev['paid_at'] = paid_at;
                prev['subscription'] = subscription;
                return prev;
            });
        }
    }
}

export const get_user_info = async (uid) => {
    const { auth_type, auth_token, domain_code } = getToken();

    const user_res = await doFetch(
        `${api_host}/api/get/user/${uid}/1`,
        'GET',
        null,
        { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
    );
    if (user_res.status) {
        const { profile, services } = user_res;
        user_info_store.set({ profile, services });
        console.log(services.length, 'services length');
        if (user_res.is_lazy_loaded) {
            new Promise(async (resolve, reject) => {
                const rest_user_res = await doFetch(
                    `${api_host}/api/get/user/${uid}/0`,
                    'GET',
                    null,
                    { Authorization: `${auth_type} ${auth_token}`, 'DomainCode': domain_code, 'Content-Type': 'application/json' }
                );
                const { services: _services } = rest_user_res;
                user_info_store.set({
                    profile,
                    services: [...services, ..._services]
                });
                console.log('next services', _services.length);
            });
        }
    } else {
        toast_message(false, user_res.msg || 'Fetching user information failed', 3000);
    }
}